import React from 'react'
import Grid from '@material-ui/core/Grid'
import AllInboxIcon from '@material-ui/icons/AllInbox'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import MobileStepper from '@material-ui/core/MobileStepper'
import Button from '@material-ui/core/Button'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import moment from 'moment'
import CardBody from '../../sharedComponents/Card/CardBody'
import useStyles from './styles'

const AnalysisCard = props => {
  const { title, setTitle, listItem, activeStep, reloadFeelings, setActiveStep, handleRemoveAnalysis } = props
  const classes = useStyles()

  return (
    <>
      {listItem.analisis?.length > 0 ? (
        <>
          <div className={classes.root}>
            <Grid container>
              <Grid item sm={10}>
                <Paper square elevation={0} className={classes.header}>
                  <CardBody>
                    {title && (
                      <>
                        <h2>Video:</h2>
                        <p>{title}</p>
                      </>
                    )}
                    <br />
                    <>
                      <Typography>
                        {' '}
                        Analisis {activeStep + 1} de {listItem.analisis?.length}{' '}
                      </Typography>
                      <Typography> Creado: {moment(listItem?.analisis[activeStep].creacion).format('ll')} </Typography>
                      <p>
                        {' '}
                        {listItem?.creo.nombre} {listItem?.creo.apellido}{' '}
                      </p>
                      <p> {listItem?.creo.correo} </p>
                    </>
                  </CardBody>
                </Paper>
              </Grid>
              <Grid item sm={2}>
                <div className={classes.justify}>
                  {title && (
                    <Tooltip title="Todos los sentimientos">
                      <IconButton
                        onClick={() => {
                          reloadFeelings()
                          setTitle('')
                        }}
                      >
                        <AllInboxIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                  <IconButton onClick={handleRemoveAnalysis}>
                    <Tooltip title="Eliminar Análisis">
                      <DeleteIcon />
                    </Tooltip>
                  </IconButton>
                </div>
              </Grid>
              <MobileStepper
                variant="dots"
                steps={listItem?.analisis.length}
                position="static"
                activeStep={activeStep}
                className={classes.root}
                nextButton={
                  <Button
                    size="small"
                    onClick={() => setActiveStep(prevActiveStep => prevActiveStep + 1)}
                    disabled={activeStep === listItem?.analisis.length - 1}
                  >
                    Next
                    <KeyboardArrowRight />
                  </Button>
                }
                backButton={
                  <Button
                    size="small"
                    onClick={() => setActiveStep(prevActiveStep => prevActiveStep - 1)}
                    disabled={activeStep === listItem?.analisis.length - listItem?.analisis.length}
                  >
                    <KeyboardArrowLeft />
                    Back
                  </Button>
                }
              />
            </Grid>
          </div>
        </>
      ) : (
        <>
          <div className={classes.center}>
            <HelpOutlineIcon />
            <p>No haz generado ningun análisis, añade videos a la lista y genera un nuevo análisis </p>
          </div>
        </>
      )}
    </>
  )
}

export default AnalysisCard
